// removed by extract-text-webpack-plugin
module.exports = {"cardFooter":"_2Ky-y","right":"_288oJ","left":"_1-Nb3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CardFooter/CardFooter.scss
// module id = 2575
// module chunks = 0